<div class="filter-editor no-field-space" *ngIf="filter">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    <div class="filter-top-toolbar">
      <div class="toolbar-layout">
        <sc-flex>
          <button mat-stroked-button (click)="cancel()" [disabled]="!this.filter.dirty">
            {{ 'cancel' |
            translate:['tmc-yard.action.cancel',
            translationService.language] }}
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button (click)="save()" [disabled]="!isSaveEnabled">
            {{ 'save' |
            translate:['tmc-yard.action.save',
            translationService.language] }}
          </button>
        </sc-flex>
      </div>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <div class="filter-details">
      <sc-flex>
        <sc-dictionary-field [model]="filter.name" [defaultLabel]="'name'" [grow]="true"
          (dictionaryChanged)="displayPropertyChanged()"
          [labelDictionaryKey]="'tmc-yard.widgets.filter-administration.filter-editor.name'" [required]="true"
          [maxlength]="255">
        </sc-dictionary-field>
        <sc-content-spacer></sc-content-spacer>
        <mat-checkbox class="form-checkbox" [(ngModel)]="filter.displayOnly" (ngModelChange)="displayPropertyChanged()">
          {{'display only' | translate: ['tmc-yard.widgets.filter-administration.filter-editor.display-only',
          translationService.language]}}
        </mat-checkbox>
      </sc-flex>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      {{ 'table columns' |translate:['tmc-yard.widgets.filter-administration.filter-editor.visible-table-columns',
      translationService.language] }}
      <app-table-column-editor class="long-field" (columnsChanged)="tableColumnsChanged($event)"
        [setMode]="columnEditorMode" [columns]="filter.tableColumns"></app-table-column-editor>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-flex>
        <mat-form-field class="flex-grow margin-right field" appearance="fill">
          <mat-label>{{'sort column' | translate: ['tmc-yard.widgets.filter-administration.filter-editor.sort-column',
            translationService.language]}}</mat-label>
          <mat-select [(ngModel)]="filter.sortColumn" (ngModelChange)="displayPropertyChanged()">
            <mat-option [value]="''">
              {{'none' | translate:
              ['tmc-yard.widgets.filter-administration.filter-editor.sort-column.none',
              translationService.language]}}
            </mat-option>
            <mat-option [value]="c.key" *ngFor="let c of tableColumns">
              {{c.dictionaryKey | translate: [c.dictionaryKey, translationService.language]}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <sc-content-spacer></sc-content-spacer>
        <mat-checkbox class="form-checkbox" [(ngModel)]="filter.sortDescending"
          (ngModelChange)="displayPropertyChanged()">
          {{'sort descending' | translate:
          ['tmc-yard.widgets.filter-administration.filter-editor.sort-descending',
          translationService.language]}}
        </mat-checkbox>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        {{'Mail Schedulings' | translate: ['tmc-common.ui.filter-administration.mail-scheduling',
        translationService.language]}}
        <button mat-icon-button (click)="editMailSchudles()">
          <sc-action-icon iconClass="fa-rotate-right"
            [iconStyle]="this.filter?.filterMailSchedules?.length > 0 ? 'value' : 'no-value'"></sc-action-icon>
        </button>
      </sc-flex>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
      <sc-scroll-pane>
        <app-node-editor [setfilterAdministrationContext]="filterAdministrationContext" [setNode]="filter.rootNode">
        </app-node-editor>
      </sc-scroll-pane>
    </sc-flex-fitting-content>

  </sc-flex>
</div>